import { TransactionShape } from ".";

export interface AccountShape {
  borrower_entity: number | null;
  discount_factor_original: string;
  discount_factor_revised: string;
  external_category: string;
  gift_is_deposited: boolean;
  id: number;
  ignored: boolean;
  for_reserves_only: boolean;
  institution_original: string;
  institution_revised: string;
  institution: string;
  joint_percent_original: string;
  joint_percent_revised: string;
  name: string;
  number_suffix_original: string;
  number_suffix_revised: string;
  number_suffix: string;
  revised_type: AssetTypes;
  source_description: string;
  source_email: string;
  source_name: string;
  source_phone: string;
  source_relationship: string;
  transactions: TransactionShape[];
  type: AssetTypes;
  usable_value: string;
  value_original: string;
  value_revised: string;
  value: string;
}

export enum AssetTypes {
  Annuity = "Annuity",
  Bond = "Bond",
  BusinessCheckingAccount = "BusinessCheckingAccount",
  CertificateOfDeposit = "CertificateOfDeposit",
  CheckingAccount = "CheckingAccount",
  EarnestMoneyCashDepositTowardPurchase = "EarnestMoneyCashDepositTowardPurchase",
  GiftOfEquity = "GiftOfEquity",
  GiftsTotal = "GiftsTotal",
  IndividualDevelopmentAccount = "IndividualDevelopmentAccount",
  LifeInsurance = "LifeInsurance",
  MoneyMarketFund = "MoneyMarketFund",
  MutualFund = "MutualFund",
  NegativeAsset = "NegativeAsset",
  NetEquity = "NetEquity",
  OtherLiquidAsset = "OtherLiquidAsset",
  Qualified529Plan = "Qualified529Plan",
  RetirementFund = "RetirementFund",
  RetirementFund401K = "RetirementFund401K",
  RetirementFundRothIRA = "RetirementFundRothIRA",
  RetirementFundTraditionalIRA = "RetirementFundTraditionalIRA",
  SavingsAccount = "SavingsAccount",
  SecuredBorrowedFunds = "SecuredBorrowedFunds",
  StockBrokerageAccount = "StockBrokerageAccount",
  StockOptions = "StockOptions",
  TrustAccount = "TrustAccount",
}

export const assetTypeToStrMap = {
  [AssetTypes.Annuity]: "Annuity",
  [AssetTypes.Bond]: "Bond",
  [AssetTypes.BusinessCheckingAccount]: "Business Checking Account",
  [AssetTypes.CertificateOfDeposit]: "Certificate Of Deposit",
  [AssetTypes.CheckingAccount]: "Checking Account",
  [AssetTypes.EarnestMoneyCashDepositTowardPurchase]: "Earnest Money Cash Deposit Toward Purchase",
  [AssetTypes.GiftOfEquity]: "Gift Of Equity",
  [AssetTypes.GiftsTotal]: "Gift",
  [AssetTypes.IndividualDevelopmentAccount]: "Individual Development Account",
  [AssetTypes.LifeInsurance]: "Life Insurance",
  [AssetTypes.MoneyMarketFund]: "Money Market Fund",
  [AssetTypes.MutualFund]: "Mutual Fund",
  [AssetTypes.NegativeAsset]: "Negative asset",
  [AssetTypes.NetEquity]: "Net Equity",
  [AssetTypes.OtherLiquidAsset]: "Other Liquid Asset",
  [AssetTypes.Qualified529Plan]: "Qualified 529 Plan",
  [AssetTypes.RetirementFund]: "Retirement Fund",
  [AssetTypes.RetirementFund401K]: "Retirement Fund 401K",
  [AssetTypes.RetirementFundRothIRA]: "Retirement Fund Roth IRA",
  [AssetTypes.RetirementFundTraditionalIRA]: "Retirement Fund Traditional IRA",
  [AssetTypes.SavingsAccount]: "Savings Account",
  [AssetTypes.SecuredBorrowedFunds]: "Secured Borrowed Funds",
  [AssetTypes.StockBrokerageAccount]: "Stock",
  [AssetTypes.StockOptions]: "Stock Options",
  [AssetTypes.TrustAccount]: "Trust Funds",
};
